var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 500,
    width: 750,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 500,
    fill: "#c60b1e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 250,
    y: 125,
    fill: "#ffc400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coa",
    stroke: "#000",
    strokeWidth: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "supporters"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown_left",
    strokeWidth: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeLinejoin: "round",
    d: "m167.99 222.24s-0.51 0-0.79-0.16-1.13-0.96-1.13-0.96l-0.68-0.49-0.62-0.85s-0.73-1.18-0.4-2.09c0.34-0.91 0.91-1.23 1.42-1.5 0.51-0.26 1.58-0.59 1.58-0.59s0.85-0.37 1.13-0.42c0.28-0.06 1.3-0.32 1.3-0.32s0.28-0.16 0.56-0.27c0.29-0.11 0.68-0.11 0.91-0.16 0.22-0.06 0.79-0.24 1.13-0.26 0.52-0.02 1.36 0.1 1.64 0.1s1.24 0.05 1.64 0.05c0.39 0 1.8-0.11 2.2-0.11 0.39 0 0.68-0.05 1.13 0 0.45 0.06 1.24 0.32 1.47 0.43s1.58 0.59 2.09 0.75 1.75 0.37 2.32 0.64c0.56 0.27 0.91 0.72 1.19 1.1 0.28 0.37 0.34 0.78 0.45 1.05 0.11 0.26 0.11 0.84 0 1.11-0.11 0.26-0.51 0.81-0.51 0.81l-0.62 1.02-0.79 0.64s-0.57 0.54-1.02 0.48c-0.45-0.04-5.03-0.86-7.97-0.86s-7.64 0.86-7.64 0.86h0.01z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.66,
    cy: 215.68,
    rx: 1.38,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.68,
    cy: 215.68,
    rx: 0.64,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "none",
    cx: 175.68,
    cy: 213.04,
    rx: 0.93,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "m176.96 212.74v0.58h-2.53v-0.58h0.94v-1.32h-0.62v-0.57h0.62v-0.57h0.6v0.57h0.62v0.57h-0.62v1.32h0.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m175.94,212.2a0.93,0.87 0 1,1 -0.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.68 222.08h-4.81l-0.11-1.18-0.23-1.23-0.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65 0.1-0.32 0.22-0.56 0.47-0.71 1.18-0.7 3.61 0.98 5.44 3.74 0.16 0.25 0.32 0.5 0.46 0.75h3.97c0.14-0.25 0.3-0.5 0.46-0.75 1.82-2.76 4.26-4.44 5.43-3.74 0.26 0.15 0.37 0.39 0.47 0.71-0.41-0.24-1.62 0.9-2.96 2.65l-0.23 1.53-0.23 1.23-0.1 1.18h-4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m167.55 215.44c0.91-0.53 3.02 1.14 4.73 3.74m11.55-3.74c-0.91-0.53-3.01 1.14-4.73 3.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_pt1",
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.58 224.25c-0.2-0.57-0.58-1.08-0.58-1.08 1.95-0.57 4.66-0.93 7.67-0.94 3.01 0.01 5.75 0.37 7.69 0.94 0 0-0.22 0.38-0.52 0.91-0.17 0.3-0.39 0.81-0.38 0.81-1.75-0.54-4.02-0.81-6.8-0.82-2.79 0.01-5.46 0.35-6.86 0.86 0.02 0-0.1-0.32-0.23-0.68h0.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.67 226.73c2.43-0.01 5.11-0.38 6.1-0.63 0.66-0.2 1.05-0.49 0.98-0.84-0.04-0.16-0.18-0.3-0.37-0.38-1.46-0.47-4.07-0.8-6.71-0.8-2.63 0-5.27 0.33-6.72 0.8-0.19 0.08-0.33 0.22-0.37 0.38-0.07 0.35 0.32 0.64 0.98 0.84 0.99 0.25 3.68 0.62 6.11 0.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.48 222.08l-0.59-0.53s-0.57 0.34-1.28 0.24c-0.7-0.11-0.93-0.97-0.93-0.97s-0.79 0.67-1.44 0.62c-0.65-0.06-1.07-0.62-1.07-0.62s-0.71 0.51-1.33 0.46c-0.62-0.06-1.21-0.83-1.21-0.83s-0.63 0.8-1.25 0.86c-0.62 0.05-1.13-0.54-1.13-0.54s-0.28 0.59-1.07 0.72-1.47-0.62-1.47-0.62-0.45 0.73-0.99 0.92c-0.54 0.18-1.24-0.27-1.24-0.27s-0.12 0.27-0.2 0.43-0.31 0.19-0.31 0.19l0.18 0.47c1.93-0.56 4.56-0.91 7.53-0.91s5.67 0.35 7.61 0.92l0.2-0.54h-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.69 219.49l0.28 0.05c-0.05 0.12-0.06 0.24-0.06 0.38 0 0.58 0.5 1.05 1.12 1.05 0.49 0 0.91-0.31 1.06-0.73 0.01 0.01 0.11-0.38 0.15-0.38 0.03 0 0.03 0.41 0.05 0.41 0.07 0.53 0.55 0.89 1.1 0.89 0.62 0 1.11-0.47 1.11-1.06 0-0.04 0-0.08-0.01-0.12l0.35-0.35 0.19 0.44c-0.07 0.14-0.1 0.29-0.1 0.46 0 0.56 0.47 1.01 1.06 1.01 0.37 0 0.69-0.18 0.88-0.45l0.23-0.29v0.36c0 0.34 0.14 0.66 0.49 0.71 0 0 0.38 0.03 0.91-0.38 0.52-0.41 0.8-0.75 0.8-0.75l0.03 0.42s-0.51 0.84-0.97 1.1c-0.25 0.15-0.64 0.31-0.95 0.25-0.32-0.05-0.55-0.31-0.67-0.61-0.23 0.14-0.51 0.22-0.8 0.22-0.63 0-1.2-0.35-1.42-0.86-0.29 0.31-0.69 0.5-1.16 0.5-0.51 0-0.97-0.23-1.26-0.58-0.28 0.27-0.67 0.43-1.09 0.43-0.55 0-1.05-0.28-1.33-0.69-0.29 0.41-0.78 0.69-1.34 0.69-0.42 0-0.81-0.16-1.09-0.43-0.29 0.35-0.75 0.58-1.25 0.58-0.48 0-0.88-0.19-1.17-0.5-0.22 0.51-0.79 0.86-1.42 0.86-0.29 0-0.56-0.08-0.79-0.22-0.12 0.3-0.35 0.56-0.68 0.61-0.3 0.06-0.69-0.1-0.94-0.25-0.47-0.26-1.02-1.1-1.02-1.1l0.07-0.42s0.29 0.34 0.81 0.75 0.91 0.38 0.91 0.38c0.34-0.05 0.49-0.37 0.49-0.71v-0.36l0.22 0.29c0.19 0.27 0.51 0.45 0.88 0.45 0.59 0 1.06-0.45 1.06-1.01 0-0.17-0.02-0.32-0.1-0.46l0.19-0.44 0.35 0.35c-0.01 0.04-0.01 0.08-0.01 0.12 0 0.59 0.49 1.06 1.11 1.06 0.55 0 1.03-0.36 1.11-0.89 0.01 0 0.01-0.41 0.04-0.41 0.05 0 0.14 0.39 0.16 0.38 0.14 0.42 0.56 0.73 1.06 0.73 0.61 0 1.11-0.47 1.11-1.05 0-0.14 0-0.26-0.05-0.38l0.29-0.05h0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m175.67 222.23c-3.01 0.01-5.72 0.37-7.67 0.94-0.13 0.04-0.29-0.06-0.33-0.17-0.04-0.13 0.05-0.28 0.18-0.32 1.95-0.6 4.73-0.98 7.82-0.98s5.88 0.38 7.83 0.98c0.13 0.04 0.22 0.19 0.18 0.32-0.04 0.11-0.2 0.21-0.33 0.17-1.95-0.57-4.67-0.93-7.68-0.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.43 221c-0.01 0.01-0.38-0.48-0.65-0.73-0.2-0.18-0.68-0.33-0.68-0.33 0-0.08 0.28-0.28 0.58-0.28 0.18 0 0.35 0.07 0.45 0.2l0.04-0.2s0.24 0.05 0.35 0.32c0.12 0.29 0.05 0.72 0.05 0.72s-0.05 0.2-0.14 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.32 220.22l-0.11 0.66-1.4 0.15-0.21-0.12 0.04-0.23 1.06-0.87 0.62 0.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.45 220.75c0.12-0.12 0.36-0.09 0.53 0.06 0.18 0.15 0.24 0.38 0.12 0.5-0.12 0.13-0.36 0.1-0.53-0.06-0.18-0.15-0.24-0.38-0.12-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.02 220.88c-0.06-0.18 0-0.37 0.13-0.42 0.14-0.03 0.3 0.09 0.37 0.27 0.06 0.19 0 0.38-0.14 0.42-0.13 0.04-0.29-0.08-0.36-0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.67 220.04l0.51 0.48 1.22-0.66 0.09-0.21-0.17-0.17-1.4-0.12-0.25 0.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.08 217.76l-0.67 0.64 0.86 1.14 0.23 0.09 0.17-0.18 0.3-1.37-0.89-0.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.36 219.3l-0.26 0.63-1.4-0.13-0.18-0.16 0.1-0.22 1.22-0.64 0.52 0.52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.51,
    cy: 219.65,
    rx: 0.49,
    ry: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.87 219.95c-0.03-0.2 0.07-0.37 0.21-0.39s0.28 0.13 0.3 0.33c0.03 0.19-0.07 0.37-0.21 0.38-0.14 0.02-0.28-0.13-0.3-0.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.78 219.24l0.4 0.57 1.34-0.42 0.14-0.18-0.15-0.2-1.33-0.39-0.4 0.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.66 217.15l-0.86 0.52 0.64 1.38 0.22 0.14 0.22-0.14 0.64-1.38-0.86-0.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.55 219.24l-0.39 0.57-1.34-0.42-0.14-0.18 0.14-0.2 1.34-0.39 0.39 0.62"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.67,
    cy: 219.21,
    rx: 0.49,
    ry: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.5 219.95c0.02-0.2-0.08-0.37-0.22-0.39s-0.28 0.13-0.3 0.33c-0.02 0.19 0.07 0.37 0.21 0.38 0.14 0.02 0.28-0.13 0.31-0.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.99 219.3l0.26 0.63 1.4-0.13 0.18-0.16-0.1-0.22-1.22-0.64-0.52 0.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.27 217.76l0.67 0.64-0.86 1.14-0.23 0.09-0.17-0.18-0.3-1.37 0.89-0.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.68 220.04l-0.51 0.48-1.22-0.66-0.1-0.21 0.19-0.17 1.4-0.12 0.24 0.68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.85,
    cy: 219.65,
    rx: 0.49,
    ry: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.34 220.88c0.06-0.18 0-0.37-0.13-0.42-0.14-0.03-0.3 0.09-0.37 0.27-0.06 0.19 0 0.38 0.14 0.42 0.13 0.04 0.29-0.08 0.36-0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.73 221c0.01 0.01 0.38-0.48 0.66-0.73 0.19-0.18 0.67-0.33 0.67-0.33 0-0.08-0.28-0.28-0.58-0.28-0.18 0-0.35 0.07-0.45 0.2l-0.04-0.2s-0.24 0.05-0.36 0.32c-0.11 0.29-0.03 0.72-0.03 0.72s0.04 0.2 0.13 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.84 220.22l0.11 0.66 1.4 0.15 0.21-0.12-0.05-0.23-1.05-0.87-0.62 0.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.74 220.75c-0.11-0.12-0.35-0.09-0.53 0.06s-0.24 0.38-0.12 0.5c0.12 0.13 0.36 0.1 0.54-0.06 0.18-0.15 0.23-0.38 0.11-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_pt2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m168.05 224.3l0.31-0.5 0.65 0.13-0.38 0.56-0.58-0.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m170.85 223.81l-0.69 0.11c-0.18 0.02-0.35-0.09-0.38-0.26-0.02-0.17 0.1-0.32 0.27-0.35l0.7-0.1 0.71-0.11c0.18-0.02 0.34 0.09 0.37 0.25 0.02 0.17-0.1 0.33-0.27 0.35l-0.71 0.11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 173.19,
    cy: 223.3,
    rx: 0.44,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m175.7 223.48h-0.96c-0.18 0-0.33-0.14-0.33-0.31s0.14-0.31 0.32-0.31h1.96c0.19 0 0.33 0.14 0.33 0.31s-0.15 0.31-0.33 0.31h-0.99"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 178.16,
    cy: 223.3,
    rx: 0.44,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m180.5 223.81l0.69 0.11c0.18 0.02 0.35-0.09 0.38-0.26 0.02-0.17-0.09-0.32-0.27-0.35l-0.7-0.1-0.71-0.11c-0.18-0.02-0.35 0.09-0.37 0.25-0.03 0.17 0.09 0.33 0.27 0.35l0.71 0.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m183.24 224.33l-0.25-0.53-0.67 0.06 0.32 0.59 0.6-0.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeLinejoin: "round",
    d: "m175.66 226.16c-2.43 0-4.63-0.22-6.3-0.65 1.67-0.43 3.87-0.69 6.3-0.7 2.44 0 4.65 0.27 6.33 0.7-1.68 0.43-3.89 0.65-6.33 0.65z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.01,
    d: "m176.8 226.08v-1.16m-0.58 1.2l0.01-1.23m-0.43 1.25v-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.02,
    d: "m175.44 226.15v-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.03,
    d: "m175.09 226.15v-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.04,
    d: "m174.77 226.15v-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.04,
    d: "m174.44 226.15v-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.05,
    d: "m174.16 226.15v-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.06,
    d: "m173.61 226.08l-0.01-1.15m0.27 1.17v-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.07,
    d: "m173.1 226.03v-1.06m0.26 1.09l-0.01-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.08,
    d: "m172.42 225.97v-0.93m0.23 0.94v-0.98m0.23 1.02v-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.09,
    d: "m172.19 225.96v-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.1,
    d: "m171.97 225.92v-0.85"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.11,
    d: "m171.73 225.89v-0.78"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.12,
    d: "m171.24 225.82l-0.01-0.62m0.26 0.66v-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.12,
    d: "m170.99 225.77v-0.55"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.13,
    d: "m170.76 225.73v-0.46"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    d: "m170.51 225.67v-0.36"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "m170.26 225.64v-0.27"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.18,
    d: "m169.99 225.58v-0.13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pillar_left"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#005bbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.28 330.68c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.32-3.91 0.83-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.54-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.33 3.92-0.86 1.01-0.52 2.4-0.84 3.91-0.84 1.5 0 2.86 0.32 3.86 0.83 1.02 0.54 2.37 0.87 3.91 0.87l0.02-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m191.28 333.09c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.83-3.86-0.83-1.51 0-2.9 0.32-3.91 0.84-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.37-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.54 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.84 3.91-0.84c1.5 0 2.86 0.32 3.86 0.84 1.02 0.53 2.37 0.86 3.91 0.86l0.02-2.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.28 335.5c-1.54 0-2.91-0.33-3.93-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.4c1.53 0 2.93-0.34 3.95-0.88 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.37 0.86 3.91 0.86l0.02-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m191.26 340.32c-1.54 0-2.89-0.33-3.91-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.31-3.91 0.83s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.53-2.42 0.88-3.95 0.88v-2.4c1.53 0 2.93-0.36 3.95-0.9 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.39 0.86 3.93 0.86l-0.02 2.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.26 342.73c-1.54 0-2.89-0.33-3.91-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v-2.39c1.53 0 2.93-0.37 3.95-0.9 1-0.52 2.34-0.81 3.86-0.81 1.45 0 2.79 0.3 3.79 0.79 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.83 3.91-0.83c1.5 0 2.86 0.31 3.86 0.82 1.02 0.54 2.38 0.87 3.93 0.87l-0.02 2.41z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m166.92 320.78c0.05 0.21 0.13 0.4 0.13 0.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-0.21 0.04-0.41 0.09-0.62-0.13 0.05-0.29 0.06-0.44 0.06h-16.69c-0.13 0-0.29-0.02-0.41-0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.33 319.27h16.69c0.57 0 1.02 0.35 1.02 0.78s-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.36-1.02-0.79s0.46-0.78 1.02-0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.27 329.86h22.87v-5.83h-22.87v5.83z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m167.55 318.32h16.25v-79.63h-16.25v79.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m179.13 238.8v79.46m1.83-79.46v79.46"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.58 232.37h22.29v-5.84h-22.29v5.84z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m166.92 236.26c0.14-0.06 0.24-0.07 0.41-0.07h16.69c0.17 0 0.32 0.03 0.46 0.08-0.58-0.19-0.99-0.71-0.99-1.32s0.45-1.14 1.03-1.33c-0.14 0.04-0.33 0.08-0.49 0.08h-16.7c-0.17 0-0.33-0.01-0.47-0.06l0.09 0.02c0.6 0.18 0.94 0.71 0.94 1.29 0 0.56-0.38 1.13-0.97 1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.33 236.19h16.69c0.57 0 1.02 0.35 1.02 0.78 0 0.44-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.35-1.02-0.79 0-0.43 0.46-0.78 1.02-0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.33 232.37h16.7c0.57 0 1.03 0.3 1.03 0.66 0 0.37-0.46 0.67-1.03 0.67h-16.7c-0.56 0-1.02-0.3-1.02-0.67 0-0.36 0.46-0.66 1.02-0.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ribbon_left",
    fill: "#ad1519"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31 0.12 0.61 0.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-0.9-3.56-2.34-4.64z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39 0.02-5.04 0.25-7.79 0.7-9.72 1.63-17.13 5.51-16.54 8.67 0.01 0.06 0.04 0.2 0.05 0.26 0 0-3.64-8.21-3.7-8.52-0.65-3.51 7.56-7.82 18.35-9.62 3.39-0.57 6.69-0.79 9.56-0.76 6.9 0 12.9 0.89 16.52 2.23l0.04 9.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.52 278.47c-4.51-0.32-7.58-1.53-7.94-3.41-0.28-1.5 1.25-3.17 3.97-4.68 1.21 0.14 2.58 0.3 4 0.3l-0.03 7.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.83 272.38c2.82 0.43 4.93 1.13 5.98 1.99l0.1 0.17c0.5 1.03-1.97 3.22-6.11 5.67l0.03-7.83"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m157.42 293.83c-0.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-0.09-0.17c0.46 0.38 1.18 8.24 1.18 8.24 0.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-0.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crown_right",
    strokeWidth: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeWidth: 0.27,
    d: "m324.85 220.42s-0.74 0.78-1.28 0.89c-0.53 0.1-1.21-0.49-1.21-0.49s-0.48 0.51-1.08 0.64c-0.59 0.14-1.41-0.66-1.41-0.66s-0.57 0.8-1.07 0.99c-0.51 0.18-1.13-0.24-1.13-0.24s-0.23 0.39-0.65 0.61c-0.18 0.09-0.48-0.05-0.48-0.05l-0.6-0.38-0.68-0.72-0.62-0.24s-0.28-0.91-0.31-1.07c-0.02-0.16-0.08-0.57-0.08-0.57-0.13-0.65 0.87-1.4 2.3-1.72 0.82-0.19 1.54-0.18 2.06-0.02 0.57-0.48 1.78-0.82 3.2-0.82 1.29 0 2.42 0.27 3.04 0.7 0.61-0.43 1.74-0.7 3.03-0.7 1.42 0 2.62 0.34 3.19 0.82 0.53-0.16 1.24-0.17 2.07 0.02 1.42 0.32 2.43 1.07 2.3 1.72 0 0-0.06 0.41-0.08 0.57-0.03 0.16-0.32 1.07-0.32 1.07l-0.62 0.24-0.68 0.72-0.58 0.38s-0.3 0.14-0.48 0.05c-0.43-0.21-0.66-0.61-0.66-0.61s-0.62 0.42-1.13 0.24c-0.51-0.19-1.07-0.99-1.07-0.99s-0.82 0.8-1.42 0.66c-0.59-0.13-1.07-0.64-1.07-0.64s-0.68 0.59-1.21 0.49c-0.54-0.11-1.27-0.89-1.27-0.89z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.82,
    cy: 216.2,
    rx: 1.38,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.85,
    cy: 216.2,
    rx: 0.63,
    ry: 1.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "none",
    cx: 324.84,
    cy: 213.95,
    rx: 0.93,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "m326.13 213.64v0.58h-2.53v-0.58h0.94v-1.3h-0.62v-0.58h0.62v-0.58h0.61v0.58h0.61v0.58h-0.61v1.3h0.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m325.11,213.12a0.93,0.88 0 1,1 -0.51,-0.01"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26,
    strokeLinecap: "round",
    d: "m314.41 219.99c-0.13-0.33-0.22-0.7-0.22-1.08 0-1.59 1.26-2.88 2.83-2.88 0.5 0 0.96 0.13 1.37 0.37"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26,
    d: "m319.48 217.93c-0.15-0.26-0.29-0.54-0.29-0.84 0-1.15 1.19-2.08 2.64-2.08 0.62 0 1.2 0.17 1.65 0.45"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26,
    d: "m330.17 217.96c0.15-0.26 0.25-0.57 0.25-0.87 0-1.15-1.18-2.08-2.64-2.08-0.62 0-1.19 0.17-1.64 0.45"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26,
    strokeLinecap: "round",
    d: "m335.21 219.99c0.13-0.33 0.21-0.7 0.21-1.08 0-1.59-1.26-2.88-2.82-2.88-0.5 0-0.97 0.13-1.38 0.37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.57,
    cy: 218.68,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.74,
    cy: 217.1,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.76,
    cy: 215.9,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.11,
    cy: 215.25,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.55,
    cy: 215.31,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 318.43,
    cy: 217.08,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.68,
    cy: 215.58,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.81,
    cy: 214.64,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.23,
    cy: 214.19,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.67,
    cy: 214.24,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.94,
    cy: 214.24,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.39,
    cy: 214.19,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.8,
    cy: 214.64,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.93,
    cy: 215.58,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 331.18,
    cy: 217.08,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.06,
    cy: 215.31,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.51,
    cy: 215.25,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.86,
    cy: 215.9,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.88,
    cy: 217.1,
    rx: 0.45,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.05,
    cy: 218.68,
    rx: 0.45,
    ry: 0.43
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crown_pt1",
    x: 149.17
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crown_pt2",
    x: 149.17
  })), /*#__PURE__*/React.createElement("use", {
    id: "pillar_right",
    xlinkHref: "#pillar_left",
    x: 149.17
  }), /*#__PURE__*/React.createElement("use", {
    id: "ribbon_right",
    xlinkHref: "#ribbon_left",
    transform: "matrix(-1,0,0,1,500.57,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus_ultra",
    fill: "#c8b100",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.42 264.65c1.99-0.72 3.29-1.58 2.66-3.14-0.41-1-1.43-1.19-2.97-0.63l-2.71 0.99 2.44 6.03c0.27-0.12 0.54-0.24 0.81-0.34 0.28-0.1 0.57-0.18 0.85-0.26l-1.08-2.64v-0.01zm-1.18-2.91l0.69-0.25c0.57-0.21 1.21 0.1 1.5 0.8 0.21 0.53 0.16 1.13-0.5 1.55-0.21 0.13-0.46 0.23-0.7 0.33l-0.99-2.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.78 259.22c-0.29 0.08-0.57 0.16-0.86 0.22-0.29 0.05-0.59 0.09-0.88 0.12l1.41 6.28 4.38-0.88c-0.05-0.12-0.12-0.26-0.14-0.38-0.03-0.14-0.03-0.28-0.04-0.41-0.77 0.22-1.61 0.46-2.61 0.66l-1.26-5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.56 264.63c0.82-2.28 1.82-4.46 2.81-6.67-0.18 0.03-0.36 0.06-0.54 0.07s-0.37 0.01-0.54 0c-0.53 1.61-1.18 3.21-1.87 4.8-0.82-1.51-1.73-2.99-2.43-4.51-0.34 0.04-0.69 0.09-1.03 0.12-0.34 0.02-0.7 0.01-1.04 0.02 1.26 2.06 2.48 4.11 3.64 6.23 0.16-0.03 0.32-0.06 0.5-0.08 0.16-0.01 0.33 0.01 0.5 0.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.72 259.8c0.15-0.31 0.31-0.6 0.48-0.89-0.24-0.22-0.96-0.55-1.81-0.63-1.79-0.18-2.81 0.61-2.93 1.69-0.26 2.26 3.31 2.07 3.14 3.57-0.07 0.64-0.75 0.9-1.48 0.83-0.81-0.08-1.41-0.53-1.51-1.19l-0.22-0.02c-0.12 0.39-0.29 0.77-0.48 1.15 0.53 0.34 1.21 0.53 1.85 0.59 1.83 0.19 3.22-0.54 3.35-1.74 0.23-2.15-3.37-2.27-3.23-3.54 0.06-0.53 0.47-0.88 1.4-0.79 0.67 0.07 1.08 0.43 1.26 0.95l0.18 0.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.3 264.98c0.62-2.33 1.41-4.58 2.19-6.87-0.17 0.05-0.35 0.09-0.53 0.11-0.17 0.03-0.36 0.04-0.54 0.05-0.37 1.64-0.88 3.29-1.42 4.94-0.96-1.44-2-2.84-2.83-4.3-0.34 0.07-0.68 0.15-1.02 0.2s-0.69 0.07-1.04 0.11c1.45 1.94 2.85 3.89 4.2 5.91 0.16-0.04 0.32-0.1 0.5-0.12 0.16-0.02 0.33-0.02 0.49-0.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.48 258.16c-0.29 0.01-0.59 0.04-0.88 0.03-0.3 0-0.6-0.04-0.89-0.06l-0.12 6.41 4.49 0.08c-0.03-0.13-0.06-0.28-0.06-0.41s0.04-0.27 0.07-0.4c-0.81 0.05-1.68 0.1-2.71 0.08l0.1-5.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.52 259.21c0.72 0.06 1.41 0.19 2.1 0.31-0.01-0.13-0.03-0.27-0.02-0.41 0.01-0.13 0.06-0.26 0.1-0.39l-6.07-0.5c0.01 0.14 0.03 0.27 0.02 0.4-0.01 0.14-0.06 0.27-0.1 0.4 0.62-0.02 1.37-0.02 2.21 0.05l-0.53 5.77c0.29 0 0.59 0 0.88 0.03 0.3 0.02 0.59 0.07 0.88 0.11l0.53-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.01 265.53c0.29 0.05 0.59 0.09 0.88 0.15 0.28 0.06 0.57 0.15 0.85 0.23l0.72-2.94 0.08 0.01c0.16 0.41 0.38 0.9 0.49 1.19l0.9 2.22c0.36 0.06 0.71 0.11 1.05 0.18 0.36 0.08 0.7 0.18 1.04 0.28l-0.31-0.67c-0.48-1-0.99-2.01-1.41-3.02 1.12 0.04 1.98-0.36 2.2-1.26 0.15-0.62-0.1-1.11-0.68-1.53-0.44-0.31-1.28-0.47-1.83-0.6l-2.44-0.53-1.54 6.29m3.14-5.42c0.71 0.16 1.59 0.27 1.59 1.07-0.01 0.21-0.03 0.35-0.06 0.48-0.23 0.94-0.94 1.26-2.13 0.91l0.6-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.57 267.46c-0.05 0.69-0.18 1.37-0.31 2.1 0.3 0.14 0.61 0.27 0.9 0.44 0.3 0.16 0.57 0.34 0.86 0.52l0.6-7.23c-0.14-0.06-0.27-0.12-0.41-0.19-0.13-0.07-0.25-0.15-0.37-0.24l-6.38 4.05c0.17 0.08 0.35 0.16 0.51 0.25 0.17 0.09 0.31 0.19 0.47 0.28 0.54-0.45 1.1-0.82 1.74-1.3l2.39 1.31v0.01zm-1.81-1.66l2.13-1.37-0.25 2.4-1.88-1.03"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crown_crest"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeWidth: 0.26,
    d: "m249.65 182.72c6.64 0 12.56 0.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47 0.33 4.81 0.39 6.85 0.24 2.73-0.06 6.67 0.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-0.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6 0.21-0.79 2.25-32.91-3.86-33.02 3.86-0.79-2.25-2.61-0.21-5.08-4.07-2.15-1.83-4.3-4.92-0.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04 0.15 4.38 0.09 6.85-0.24 3.24-0.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m225.34 191.42l1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-0.31 0.02-0.61 0.06-0.91 0.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63 0.95 8.84 2.48 0.06-0.67 0.12-1.25 0.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41 0.33-2.75 0.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23 0.23 6.14 0.67-0.42 0.46-0.75 0.97-1.08 1.48-1.59-0.31-3.29-0.48-5.06-0.48-7.27 0-13.36 2.83-15.12 6.65-0.47 0.97-0.73 2.06-0.73 3.2 0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-0.58 1.2-0.91 2.54-0.91 3.95 0 2.33 0.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.04 171.27c1.76 0 3.28 1.16 3.64 2.73 0.23 1.38 0.38 2.95 0.41 4.62 0.01 0.18-0.01 0.35-0.01 0.52 0 0.2 0.04 0.41 0.05 0.61 0.06 3.52 0.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c0.72-1.9 1.22-5 1.29-8.52 0-0.2 0.04-0.41 0.04-0.61 0-0.17-0.01-0.34-0.01-0.52 0.03-1.67 0.18-3.24 0.41-4.62 0.36-1.57 1.94-2.73 3.7-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.04 172.94c0.91 0 1.68 0.58 1.87 1.39 0.23 1.31 0.37 2.8 0.4 4.38 0 0.16-0.01 0.32-0.01 0.48 0 0.2 0.03 0.39 0.04 0.59 0.05 3.32 0.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c0.67-1.8 1.15-4.73 1.21-8.05 0-0.2 0.04-0.39 0.04-0.59 0-0.16-0.01-0.32-0.01-0.48 0.03-1.58 0.17-3.07 0.4-4.38 0.18-0.81 1.02-1.39 1.93-1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.7 191.42l-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-0.31-0.02-0.61-0.06-0.91-0.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63 0.95-8.84 2.48-0.06-0.67-0.12-1.25-0.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-0.33-2.75-0.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23 0.23-6.15 0.67 0.43 0.46 0.76 0.97 1.09 1.48 1.58-0.31 3.29-0.48 5.06-0.48 7.27 0 13.35 2.83 15.11 6.65 0.47 0.97 0.73 2.06 0.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34 0.58 1.2 0.91 2.54 0.91 3.95 0 2.33-0.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#005bbf",
    strokeWidth: 0.26,
    cx: 250.05,
    cy: 167.3,
    rx: 4.43,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26,
    d: "m248.89 155.54v2.26h-2.42v2.3h2.42v3.15 3.46h-3.05c-0.03 0.21-0.22 0.37-0.22 0.59 0 0.58 0.12 1.14 0.35 1.64 0 0.02 0.02 0.02 0.03 0.03h8.12c0-0.01 0.02-0.01 0.03-0.03 0.22-0.5 0.35-1.06 0.35-1.64 0-0.22-0.19-0.38-0.22-0.59h-2.96v-3.43-3.18h2.42v-2.3h-2.42v-2.26h-2.43z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.04,
    cy: 188.94,
    rx: 1.91,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.04,
    cy: 185.4,
    rx: 1.91,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.04,
    cy: 181.6,
    rx: 1.52,
    ry: 1.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.04,
    cy: 178.18,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.04,
    cy: 175.18,
    rx: 0.88,
    ry: 0.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.94,
    cy: 198.67,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.44,
    cy: 196.02,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.44,
    cy: 192.94,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.31,
    cy: 189.64,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.12,
    cy: 186.4,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.81,
    cy: 183.45,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.06,
    cy: 181.02,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.68,
    cy: 179.01,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.8,
    cy: 177.36,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.04,
    cy: 176.19,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.66,
    cy: 175.54,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.1,
    cy: 175.36,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.47,
    cy: 175.48,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.21,
    cy: 190.32,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.34,
    cy: 187.65,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.35,
    cy: 184.75,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.47,
    cy: 181.57,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.16,
    cy: 178.37,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.84,
    cy: 175.48,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.4,
    cy: 173.47,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.39,
    cy: 171.81,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.7,
    cy: 170.82,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.13,
    cy: 170.23,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.5,
    cy: 170.28,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.99,
    cy: 170.87,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.23,
    cy: 171.99,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.8,
    cy: 171.99,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.04,
    cy: 170.87,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.54,
    cy: 170.28,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.9,
    cy: 170.23,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.34,
    cy: 170.82,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.64,
    cy: 171.81,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.64,
    cy: 173.47,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.19,
    cy: 175.48,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.88,
    cy: 178.37,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.57,
    cy: 181.57,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.69,
    cy: 184.75,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.69,
    cy: 187.65,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.83,
    cy: 190.32,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.57,
    cy: 175.48,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.94,
    cy: 175.36,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.38,
    cy: 175.54,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 176.19,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.24,
    cy: 177.36,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.36,
    cy: 179.01,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.97,
    cy: 181.02,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.22,
    cy: 183.45,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.91,
    cy: 186.4,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.72,
    cy: 189.64,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.6,
    cy: 192.94,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.6,
    cy: 196.02,
    rx: 1.1,
    ry: 1.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.1,
    cy: 198.67,
    rx: 1.1,
    ry: 1.04
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.15 226.18c-12.26-0.02-23.25-1.47-31.09-3.83-0.57-0.18-0.87-0.7-0.84-1.25-0.01-0.52 0.29-1 0.84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27 0.02 23.25 1.47 31.09 3.83 0.55 0.17 0.84 0.65 0.83 1.17 0.03 0.55-0.27 1.07-0.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.07 216.09c-12.41 0.03-23.55 1.58-31.39 4 0.65-0.31 0.59-1.12-0.22-3.2-0.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44 0.02 25.6 1.62 34.27 4.18 0 0-1.53-0.11-2.51 2.42-0.81 2.08-0.87 2.89-0.21 3.2-7.84-2.42-19.19-3.97-31.6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.12 210.3c-13.43 0.02-25.5 1.62-34.16 4.18-0.58 0.17-1.19-0.05-1.38-0.6s0.12-1.18 0.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77 0.03 26.19 1.71 34.9 4.38 0.58 0.17 0.89 0.8 0.7 1.35s-0.8 0.77-1.38 0.6c-8.67-2.56-20.78-4.16-34.22-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.2 199.78l1.23 0.22c-0.19 0.5-0.24 1.05-0.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21 0.08 0.05 0.47-1.68 0.68-1.66 0.17 0.02 0.15 1.8 0.22 1.77 0.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-0.19-0.01-0.38-0.04-0.57l1.54-1.52 0.83 1.94c-0.33 0.61-0.46 1.3-0.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-0.78 3.9-1.97l0.99-1.25-0.01 1.53c0 1.55 0.66 2.93 2.16 3.18 0 0 1.73 0.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l0.2 1.8s-1.9 2.95-3.97 4.15c-1.14 0.66-2.86 1.35-4.23 1.13-1.44-0.24-2.48-1.4-3.01-2.74-1.03 0.61-2.25 0.97-3.55 0.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56-1.27 1.16-2.98 1.87-4.88 1.87-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-0.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-0.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-0.36-3.55-0.97-0.54 1.34-1.57 2.5-3.02 2.74-1.36 0.22-3.08-0.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l0.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-0.25 2.16-1.63 2.16-3.18l-0.01-1.53 0.99 1.25c0.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-0.73-0.13-1.42-0.46-2.03l0.83-1.94 1.54 1.52c-0.02 0.19-0.04 0.38-0.04 0.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93 0.06 0.03 0.05-1.75 0.22-1.77 0.2-0.02 0.6 1.71 0.67 1.66 0.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-0.58-0.03-1.13-0.24-1.63l1.29-0.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.37 206.32c-0.11-0.37-0.35-0.75-0.72-1.06-0.79-0.68-1.84-0.79-2.36-0.25-0.07 0.07-0.13 0.17-0.17 0.25 0 0-1.11-2.08-2.41-2.78-1.29-0.7-3.49-0.52-3.49-0.52 0-1.6 1.3-2.89 2.99-2.89 0.99 0 1.92 0.41 2.48 1.11l0.23-1.07s1.36 0.27 1.98 1.82-0.06 3.8-0.06 3.8 0.34-0.96 0.85-1.61c0.51-0.64 1.81-1.34 2.49-1.66 0.67-0.31 1.37-0.79 1.37-0.79s0.03 0.18 0.05 0.61c0.03 0.51-0.01 0.83-0.01 0.83 1.24-0.17 2.69 0.04 3.83 0.48-0.49 0.95-1.41 1.84-2.62 2.3 0 0 0.44 0.36 0.83 0.75 0.34 0.34 0.44 0.49 0.44 0.49s-0.85 0.13-1.27 0.19c-0.43 0.05-1.84 0.28-2.69 0.22-0.62-0.04-1.32-0.14-1.74-0.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m205.29 205.01c0.52-0.54 1.57-0.43 2.36 0.25 0.8 0.67 1.02 1.66 0.51 2.19-0.51 0.54-1.57 0.42-2.36-0.25-0.79-0.68-1.02-1.66-0.51-2.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m216.39 205.91c-0.28-0.83-0.03-1.65 0.57-1.83 0.6-0.19 1.32 0.33 1.6 1.16s0.03 1.65-0.57 1.84c-0.6 0.18-1.31-0.34-1.6-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.12 201.86c-0.33-0.27-0.59-0.64-0.67-1.08s0.01-0.87 0.23-1.23c0 0-0.88-0.44-1.83-0.69-0.72-0.19-1.99-0.2-2.37-0.2-0.38-0.02-1.15-0.03-1.15-0.03s0.07 0.17 0.28 0.55c0.27 0.46 0.5 0.75 0.5 0.75-1.27 0.29-2.35 1.12-3.03 2.09 0.99 0.68 2.3 1.1 3.6 0.97 0 0-0.12 0.34-0.2 0.86-0.06 0.43-0.06 0.61-0.06 0.61s0.71-0.26 1.07-0.39c0.35-0.13 1.54-0.55 2.15-0.96 0.8-0.54 1.48-1.25 1.48-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.68 191.65c1.06 0.67 1.98 1.79 2.3 3.03 0 0 0.13-0.25 0.71-0.59 0.59-0.33 1.09-0.32 1.09-0.32s-0.17 0.97-0.25 1.32c-0.09 0.34-0.09 1.38-0.32 2.32-0.23 0.93-0.63 1.68-0.63 1.68-0.42-0.34-0.99-0.51-1.58-0.41-0.58 0.1-1.06 0.44-1.32 0.9 0 0-0.66-0.58-1.21-1.38-0.55-0.81-0.93-1.78-1.13-2.08-0.21-0.3-0.72-1.15-0.72-1.15s0.47-0.18 1.14-0.05c0.67 0.12 0.88 0.32 0.88 0.32-0.14-1.28 0.28-2.62 1.04-3.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.97 201.38c0.22-0.35 0.32-0.79 0.24-1.23s-0.32-0.81-0.66-1.07c0 0 0.67-0.71 1.47-1.26 0.6-0.41 1.8-0.82 2.15-0.95 0.36-0.13 1.07-0.4 1.07-0.4s0 0.18-0.06 0.61c-0.08 0.52-0.2 0.87-0.2 0.87 1.3-0.14 2.62 0.29 3.61 0.98-0.69 0.97-1.77 1.79-3.04 2.08 0 0 0.23 0.28 0.5 0.74 0.21 0.39 0.28 0.56 0.28 0.56s-0.77-0.02-1.15-0.03c-0.38 0-1.65-0.01-2.37-0.2-0.95-0.25-1.84-0.69-1.84-0.69"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ad1519",
    cx: 227.37,
    cy: 200.45,
    rx: 2.17,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m237.76 201.77c-0.11-0.87 0.31-1.63 0.93-1.7 0.63-0.07 1.23 0.57 1.34 1.44 0.11 0.86-0.3 1.63-0.93 1.7-0.62 0.07-1.22-0.57-1.34-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.5 199.83c-0.32-0.36-0.53-0.82-0.53-1.33 0-0.5 0.19-0.97 0.51-1.32 0 0-0.89-0.67-1.89-1.12-0.77-0.35-2.18-0.59-2.6-0.67-0.43-0.08-1.28-0.24-1.28-0.24s0.04 0.2 0.2 0.67c0.2 0.56 0.4 0.93 0.4 0.93-1.47 0.08-2.85 0.81-3.81 1.76 0.96 0.94 2.34 1.66 3.81 1.75 0 0-0.2 0.36-0.4 0.93-0.16 0.46-0.2 0.67-0.2 0.67s0.85-0.16 1.28-0.24c0.42-0.08 1.83-0.32 2.6-0.67 1-0.46 1.91-1.11 1.91-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.11 188.36c1.05 0.95 1.85 2.36 1.95 3.82 0 0 0.19-0.27 0.91-0.53 0.73-0.26 1.28-0.16 1.28-0.16s-0.39 1.05-0.55 1.42c-0.17 0.37-0.39 1.53-0.84 2.53-0.44 1-1.05 1.76-1.05 1.76-0.4-0.45-1-0.75-1.67-0.75-0.68 0-1.27 0.3-1.67 0.75 0 0-0.61-0.76-1.05-1.76-0.45-1-0.67-2.16-0.84-2.53s-0.56-1.42-0.56-1.42 0.56-0.1 1.28 0.16 0.92 0.53 0.92 0.53c0.1-1.46 0.86-2.87 1.89-3.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.76 199.83c0.33-0.36 0.53-0.82 0.53-1.33 0-0.5-0.19-0.97-0.51-1.32 0 0 0.89-0.67 1.9-1.12 0.76-0.35 2.17-0.59 2.6-0.67 0.42-0.08 1.26-0.24 1.26-0.24s-0.02 0.2-0.19 0.67c-0.2 0.56-0.4 0.93-0.4 0.93 1.47 0.08 2.86 0.81 3.81 1.76-0.95 0.94-2.33 1.66-3.81 1.75 0 0 0.2 0.36 0.4 0.93 0.16 0.46 0.19 0.67 0.19 0.67l-1.26-0.24c-0.43-0.08-1.84-0.32-2.6-0.67-1.01-0.46-1.92-1.11-1.92-1.11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ad1519",
    cx: 250.14,
    cy: 198.5,
    rx: 2.17,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m262.58 201.77c0.11-0.87-0.3-1.63-0.93-1.7s-1.23 0.57-1.34 1.44c-0.11 0.86 0.31 1.63 0.93 1.7 0.63 0.07 1.23-0.57 1.34-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.38 201.38c-0.22-0.35-0.32-0.79-0.25-1.23 0.09-0.44 0.33-0.81 0.67-1.07 0 0-0.67-0.71-1.47-1.26-0.61-0.41-1.8-0.82-2.16-0.95-0.35-0.13-1.06-0.4-1.06-0.4s-0.01 0.18 0.06 0.61c0.08 0.52 0.19 0.87 0.19 0.87-1.29-0.14-2.61 0.29-3.6 0.98 0.68 0.97 1.77 1.79 3.03 2.08 0 0-0.23 0.28-0.49 0.74-0.22 0.39-0.28 0.56-0.28 0.56l1.14-0.03c0.38 0 1.66-0.01 2.37-0.2 0.95-0.25 1.84-0.69 1.84-0.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.67 191.65c-1.06 0.67-1.98 1.79-2.31 3.03 0 0-0.12-0.25-0.71-0.59-0.58-0.33-1.09-0.32-1.09-0.32s0.17 0.97 0.26 1.32c0.09 0.34 0.09 1.38 0.31 2.32 0.23 0.93 0.64 1.68 0.64 1.68 0.42-0.34 0.99-0.51 1.57-0.41 0.59 0.1 1.06 0.44 1.33 0.9 0 0 0.66-0.58 1.21-1.38 0.54-0.81 0.92-1.78 1.12-2.08 0.21-0.3 0.72-1.15 0.72-1.15s-0.47-0.18-1.14-0.05c-0.67 0.12-0.88 0.32-0.88 0.32 0.15-1.28-0.28-2.62-1.03-3.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.22 201.86c0.34-0.27 0.6-0.64 0.67-1.08 0.09-0.44 0-0.87-0.22-1.23 0 0 0.88-0.44 1.83-0.69 0.72-0.19 1.99-0.2 2.36-0.2 0.39-0.02 1.15-0.03 1.15-0.03s-0.06 0.17-0.28 0.55c-0.26 0.46-0.49 0.75-0.49 0.75 1.26 0.29 2.34 1.12 3.03 2.09-0.99 0.68-2.31 1.1-3.6 0.97 0 0 0.11 0.34 0.19 0.86 0.06 0.43 0.06 0.61 0.06 0.61s-0.71-0.26-1.06-0.39c-0.36-0.13-1.55-0.55-2.16-0.96-0.79-0.54-1.48-1.25-1.48-1.25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ad1519",
    cx: 272.98,
    cy: 200.45,
    rx: 2.17,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m283.96 205.91c0.28-0.83 0.03-1.65-0.57-1.83-0.6-0.19-1.32 0.33-1.61 1.16-0.28 0.83-0.03 1.65 0.57 1.84 0.6 0.18 1.32-0.34 1.61-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.97 206.32c0.11-0.37 0.36-0.75 0.72-1.06 0.79-0.68 1.85-0.79 2.36-0.25 0.07 0.07 0.14 0.17 0.18 0.25 0 0 1.1-2.08 2.4-2.78s3.5-0.52 3.5-0.52c0-1.6-1.31-2.89-3-2.89-0.99 0-1.92 0.41-2.47 1.11l-0.23-1.07s-1.36 0.27-1.98 1.82 0.05 3.8 0.05 3.8-0.33-0.96-0.84-1.61c-0.51-0.64-1.81-1.34-2.49-1.66-0.68-0.31-1.37-0.79-1.37-0.79s-0.03 0.18-0.06 0.61c-0.02 0.51 0.02 0.83 0.02 0.83-1.25-0.17-2.7 0.04-3.83 0.48 0.48 0.95 1.4 1.84 2.61 2.3 0 0-0.43 0.36-0.83 0.75-0.33 0.34-0.43 0.49-0.43 0.49s0.85 0.13 1.27 0.19c0.43 0.05 1.84 0.28 2.68 0.22 0.63-0.04 1.32-0.14 1.74-0.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m295.05 205.01c-0.51-0.54-1.57-0.43-2.36 0.25-0.79 0.67-1.02 1.66-0.51 2.19 0.51 0.54 1.57 0.42 2.36-0.25 0.79-0.68 1.02-1.66 0.51-2.19"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeLinejoin: "round",
    d: "m250.12 224.57c-11.06-0.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07 0.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.05,
    d: "m258.04 224.28v-6.01m-3.02 6.21l0.04-6.37m-2.24 6.45v-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.09,
    d: "m250.95 224.64v-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    d: "m249.16 224.64v-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.18,
    d: "m247.48 224.64v-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.23,
    d: "m245.81 224.64v-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.28,
    d: "m244.32 224.64v-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.33,
    d: "m241.48 224.28l-0.04-5.97m1.39 6.05v-6.25"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.37,
    d: "m238.86 224.01v-5.5m1.33 5.66l-0.04-5.86"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.42,
    d: "m235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.46,
    d: "m234.12 223.66v-4.68"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.51,
    d: "m232.97 223.42v-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.56,
    d: "m231.74 223.31v-4.06"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "m229.22 222.95l-0.04-3.22m1.33 3.38v-3.62"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.63,
    d: "m227.93 222.68v-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.68,
    d: "m226.74 222.45v-2.36"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.73,
    d: "m225.45 222.13v-1.85"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.77,
    d: "m224.12 221.98v-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.91,
    d: "m222.72 221.66v-0.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72 0.02 22.31 1.36 30.06 3.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m216.72 217.16l1.22-1.59 3.37 0.43-2.69 1.96-1.9-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m224.03 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m233.64 215.07l-2.36 0.27c-0.61 0.07-1.17-0.33-1.24-0.9-0.08-0.57 0.35-1.09 0.96-1.15l2.37-0.28 2.42-0.28c0.6-0.07 1.15 0.33 1.22 0.9s-0.36 1.09-0.96 1.16l-2.41 0.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m240.54 213.35c0-0.58 0.49-1.04 1.1-1.04 0.6 0 1.1 0.46 1.1 1.04 0 0.57-0.5 1.04-1.1 1.04-0.61 0-1.1-0.47-1.1-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m250.15 214.16h-3.29c-0.6 0-1.11-0.46-1.11-1.03 0-0.58 0.49-1.04 1.1-1.04h6.64c0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.51 1.03-1.11 1.03h-3.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m257.56 213.35c0-0.58 0.5-1.04 1.1-1.04 0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.49 1.04-1.1 1.04-0.6 0-1.1-0.47-1.1-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m266.66 215.07l2.36 0.27c0.6 0.07 1.17-0.33 1.24-0.9s-0.36-1.09-0.96-1.15l-2.37-0.28-2.42-0.28c-0.61-0.07-1.15 0.33-1.22 0.9-0.08 0.57 0.36 1.09 0.96 1.16l2.41 0.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m274.07 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m283.57 217.16l-1.21-1.59-3.37 0.43 2.69 1.96 1.89-0.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shield",
    strokeWidth: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Granada"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3h100.42v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd691",
    d: "m252.91 329.55c2.09 0.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-0.06-0.19-0.24-0.5-0.22-0.23-0.64-0.66-0.64-0.66s0.79-0.15 1.25 0.02c0.46 0.18 0.77 0.47 0.77 0.47s0.21-0.43 0.52-0.76c0.3-0.33 0.7-0.53 0.7-0.53s0.46 0.38 0.61 0.64c0.15 0.27 0.25 0.59 0.25 0.59s0.42-0.35 0.79-0.49c0.37-0.15 0.84-0.26 0.84-0.26s-0.13 0.46-0.22 0.69-0.14 0.72-0.14 0.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-0.47-4.69-0.09-5.76-0.15 0.03 0.03 1.29 0.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22 0.81 6.19-0.2 6.19-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m251.46 340.56s2.54-2.66 5.21-3.02c3.15-0.44 5.22 0.26 6.44 0.58 0.03 0-1.01 0.49-1.56 0.87-0.55 0.37-1.97 1.57-4.14 1.59-2.18 0.03-4.58-0.23-4.97-0.17-0.4 0.06-0.98 0.15-0.98 0.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m250.69 337.28c-1-0.93-1.62-2.25-1.62-3.72 0-1.46 0.62-2.78 1.63-3.71 0.99 0.93 1.61 2.25 1.61 3.71 0 1.47-0.62 2.79-1.62 3.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m249.68 342.71s0.61-1.52 0.67-2.83c0.06-1.09-0.15-2.17-0.15-2.17h0.52 0.28s0.39 1.16 0.39 2.17c0 1.02-0.18 2.37-0.18 2.37s-0.55 0.08-0.73 0.17c-0.19 0.09-0.8 0.29-0.8 0.29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Aragon",
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.03 314.12c0.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-0.07 33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.08 334.23c1.57 0.83 3.72 2.22 6.03 2.77l-0.15-56.96h-5.88v54.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.28 338.25c2.3 0.23 4.01 0.19 5.87 0v-58.21h-5.87v58.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.32 337c2.3-0.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-0.15 56.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.81 329.24c2.45-2.18 4.75-7.12 5.59-12.76l0.14-36.44h-5.87l0.14 49.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Navarre"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chains_half",
    fill: "#c8b100",
    stroke: "#c8b100",
    strokeWidth: 0.26,
    d: "m272.71,306.14c0.05-0.14,0.12-0.27,0.19-0.4l-4.26-4.74-1.67,0.72-3.06-3.39,1-1.46-5.34-5.99c-0.07,0.02-0.2,0.02-0.27,0.04l0.03,4.02,1.75,0.5v4.46l-1.75,0.48-0.03,4.08c0.84,0.26,1.48,0.88,1.74,1.67l3.21,0.01,0.51-1.67h4.72l0.5,1.67zm-6.98-18.5,0,1.61,2.76,0,0-1.61zm-7.3,20.37c0.64,0,1.16-0.49,1.16-1.1s-0.52-1.11-1.16-1.11c-0.65,0-1.17,0.5-1.17,1.11s0.52,1.1,1.17,1.1zm15.99-9.73-1.76-0.48,0-4.46,1.76-0.5-0.01-1.92c-0.85-0.25-1.51-0.87-1.79-1.67h-2.68l-0.51,1.67h-4.71l-0.51-1.67h-3.09c-0.08,0.22-0.17,0.42-0.29,0.61l5.38,5.96,1.67-0.71,3.06,3.4-1,1.45,4.18,4.64c0.09-0.04,0.18-0.08,0.28-0.12zm-7.25-1.39-1.29,1.04,1.77,1.98,1.29-1.05zm8.00432,36.1859c-1.23998-0.065-2.25509-0.9022-2.51432-2.01593-1.67-0.23-3.25-0.66-4.73-1.3l0.84-1.43c1.29,0.55,2.66,0.91,4.08,1.11,0.31-0.66,0.86-1.16,1.58-1.4l0.01-5.62-1.76-0.49v-4.46l1.76-0.48v-7.64c-0.07-0.02-0.13-0.05-0.2-0.09l-3.98,4.42,1,1.44-3.06,3.4-1.67-0.71-3.3,3.67c0.57,0.87,0.55,2-0.11,2.85,0.94,1.05,2.03,1.98,3.24,2.75l-0.84,1.44c-1.42-0.89-2.7-1.99-3.79-3.22-0.87,0.26-1.86,0.11-2.6-0.5-1.15-0.93-1.29-2.56-0.3-3.64l0.14-0.16c-0.69-1.56-1.16-3.24-1.32-5l1.71,0.01c0.14,1.5,0.51,2.93,1.09,4.27,0.49-0.06,1-0.01,1.46,0.16l3.32-3.68-1-1.45,3.06-3.4,1.67,0.72,3.99-4.43c-0.09-0.14-0.15-0.29-0.21-0.46l-2.76,0.01-0.5,1.67h-4.72l-0.51-1.67-3.24-0.01c-0.27,0.76-0.9,1.36-1.69,1.62l-0.01,4.04-1.71-0.01v-4.01c-1.1-0.33-1.91-1.31-1.91-2.47,0-1.15,0.82-2.15,1.92-2.48l0.01-4.05-1.76-0.48v-4.46l1.76-0.5v-4.05c-1.08-0.35-1.84-1.32-1.84-2.45,0-1.43,1.22-2.58,2.73-2.58,1.22,0,2.25,0.74,2.61,1.78h3.09l0.51-1.67h4.71l0.51,1.67h2.68c0.35692-1.0311,1.36258-1.76731,2.55896-1.77984l0.0711,8.36984h-0.85v2.61h0.845l-0.0214,21.59h-0.7836v2.61h0.77946zm-5.914-18.306l-1.29-1.04-1.78,1.98,1.29,1.04zm-9.96-18.44-1.69,0-0.01,2.61,1.7,0zm9.16,11.41,0-1.6-2.85,0,0,1.6zm-10.6,9.69-1.76-0.39-0.25-4.45,1.75-0.58,0,2.56c0,0.99,0.09,1.92,0.26,2.86zm1.46-5.52,1.75,0.41s0.09,2.87,0.05,2.22c-0.04-0.74,0.19,2.24,0.19,2.24l-1.76,0.58c-0.18-0.9-0.24-1.84-0.24-2.79zm10.81,16.93,0.39-1.7c-1.52-0.48-2.93-1.18-4.17-2.09l-1.26,1.11c1.48,1.15,3.19,2.08,5.04,2.68zm-0.85,1.44-1.3,1.22c-1.47-0.54-2.86-1.26-4.12-2.11l0.38-1.77c1.5,1.13,3.21,2.03,5.04,2.66z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chains_half",
    transform: "matrix(-1,0,0,1,550.43,0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "none",
    d: "m272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Castile",
    fill: "#c8b100",
    strokeWidth: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    strokeWidth: 0.52,
    d: "m200.12 281.25h50.18v-55.72h-50.18v55.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.34 238.41h-0.92v-0.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.93v-0.92h-1.61v0.92h-1.16v-0.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v0.93h-0.93v-0.93h-1.62v0.93h-0.92v-0.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.92v-0.92h-1.85v0.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.05 273.54v-4.86c0-0.92-0.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.19 268.91l-2.31-0.23c0-0.92 0.23-2.31 0.93-2.77l2.08 1.62c-0.23 0.23-0.7 0.92-0.7 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.12 266.6l1.16-2.08c-0.46-0.23-1.39-0.46-2.08-0.46-0.46 0-1.39 0.23-1.85 0.46l1.15 2.08h1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.43 268.91l2.31-0.23c0-0.92-0.23-2.31-0.92-2.77l-2.08 1.62c0.23 0.23 0.69 0.92 0.69 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.73 260.83v-5.09c0-1.38-0.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.89 260.83v-5.09c0-1.38 0.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.11 248.35l0.23-4.62h-4.39l0.47 4.62h3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.05 248.35l0.46-4.62h-4.39l0.23 4.62h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.51 248.35l-0.46-4.62h4.62l-0.46 4.62h-3.7z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0039f0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.43 273.54v-4.16c0-0.7-0.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.27 260.36v-4.39c0-1.15-0.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.36 260.36v-4.39c0-1.15 0.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Leon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m250.28 281.25h50.32v-55.72h-50.32v55.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    strokeWidth: 0.39,
    d: "m275.93 239.26l0.05-0.62 0.09-0.34s-1.61 0.13-2.46-0.11-1.61-0.59-2.4-1.25c-0.79-0.68-1.1-1.1-1.67-1.18-1.36-0.22-2.4 0.4-2.4 0.4s1.02 0.37 1.78 1.31 1.59 1.41 1.95 1.53c0.59 0.18 2.66 0.05 3.22 0.07 0.57 0.03 1.84 0.19 1.84 0.19z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed72aa",
    d: "m283.46 237s0.01 0.72 0.08 1.4c0.06 0.67-0.22 1.24-0.11 1.61s0.16 0.66 0.3 0.93c0.14 0.26 0.21 0.94 0.21 0.94s-0.38-0.28-0.74-0.54c-0.35-0.27-0.6-0.44-0.6-0.44s0.07 0.72 0.1 1.03c0.04 0.31 0.22 0.89 0.51 1.24 0.29 0.33 0.87 0.89 1.05 1.33 0.18 0.45 0.14 1.44 0.14 1.44s-0.46-0.75-0.87-0.89c-0.39-0.14-1.26-0.62-1.26-0.62s0.79 0.79 0.79 1.55c0 0.75-0.32 1.6-0.32 1.6s-0.36-0.68-0.83-1.12c-0.47-0.45-1.13-0.9-1.13-0.9s0.52 1.17 0.52 1.95c0 0.79-0.15 2.47-0.15 2.47s-0.39-0.64-0.79-0.96c-0.4-0.31-0.87-0.58-1.02-0.78-0.14-0.21 0.48 0.64 0.54 1.16 0.07 0.51 0.32 2.35 1.92 4.69 0.94 1.37 2.39 3.77 5.5 2.98 3.11-0.78 1.96-4.97 1.3-6.92-0.65-1.95-0.98-4.11-0.94-4.87 0.04-0.75 0.58-2.97 0.51-3.39-0.07-0.41-0.24-2 0.14-3.28 0.4-1.33 0.73-1.85 0.95-2.4 0.21-0.55 0.39-0.86 0.46-1.34s0.07-1.37 0.07-1.37 0.58 1.06 0.73 1.44c0.14 0.38 0.14 1.5 0.14 1.5s0.11-1.12 0.98-1.67 1.88-1.13 2.13-1.44 0.33-0.51 0.33-0.51-0.08 1.92-0.62 2.67c-0.36 0.49-1.77 2.09-1.77 2.09s0.73-0.28 1.23-0.3c0.51-0.04 0.87 0 0.87 0s-0.62 0.48-1.41 1.64c-0.8 1.16-0.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08 0.87-0.5 4.34-0.36 4.86 0.15 0.51 2.03 4.76 2.07 5.79 0.03 1.03 0.21 3.33-1.6 4.8-1.16 0.95-3.07 0.96-3.51 1.23-0.43 0.28-1.29 1.13-1.29 2.91 0 1.79 0.64 2.06 1.15 2.51 0.51 0.44 1.16 0.2 1.3 0.55 0.15 0.34 0.22 0.54 0.44 0.75 0.21 0.2 0.36 0.44 0.29 0.82-0.08 0.38-0.91 1.23-1.2 1.85-0.29 0.61-0.87 2.23-0.87 2.47s-0.07 0.99 0.18 1.37c0 0 0.91 1.06 0.29 1.26-0.4 0.14-0.78-0.25-0.97-0.2-0.54 0.14-0.83 0.47-0.98 0.45-0.36-0.07-0.36-0.25-0.4-0.76-0.03-0.51-0.01-0.72-0.17-0.72-0.22 0-0.33 0.18-0.37 0.45s-0.04 0.89-0.29 0.89-0.61-0.45-0.83-0.55-0.83-0.2-0.87-0.48c-0.03-0.27 0.36-0.85 0.76-0.96 0.4-0.1 0.76-0.3 0.51-0.51-0.26-0.2-0.51-0.2-0.76 0-0.25 0.21-0.79 0.04-0.76-0.27 0.04-0.31 0.11-0.69 0.07-0.86-0.03-0.17-0.47-0.51 0.1-0.82 0.59-0.31 0.84 0.27 1.42 0.17s0.86-0.31 1.08-0.65 0.18-1.06-0.22-1.5c-0.39-0.45-0.79-0.52-0.94-0.8-0.14-0.27-0.36-0.92-0.36-0.92s0.11 1.2 0.04 1.37-0.04 0.89-0.04 0.89-0.39-0.45-0.72-0.79c-0.32-0.34-0.65-1.37-0.65-1.37s-0.03 0.96-0.03 1.34c0 0.37 0.43 0.72 0.29 0.86-0.15 0.13-0.83-0.72-1.02-0.86-0.18-0.14-0.76-0.58-1.01-1.06s-0.44-1.16-0.51-1.41c-0.07-0.24-0.19-1.31-0.07-1.58 0.18-0.4 0.47-1.13 0.47-1.13h-1.41c-0.76 0-1.3-0.23-1.59 0.28s-0.15 1.54 0.21 2.88c0.37 1.33 0.58 1.98 0.48 2.22-0.11 0.24-0.58 0.79-0.76 0.89-0.19 0.11-0.69 0.07-0.91-0.03-0.21-0.1-0.57-0.27-1.26-0.27s-1.12 0.03-1.37-0.03c-0.26-0.07-0.88-0.38-1.17-0.31s-0.79 0.32-0.65 0.72c0.22 0.61-0.21 0.75-0.51 0.72-0.29-0.04-0.53-0.14-0.9-0.24-0.36-0.11-0.9 0-0.83-0.42 0.07-0.41 0.22-0.44 0.4-0.74 0.18-0.32 0.25-0.52 0.04-0.54-0.25-0.02-0.51-0.05-0.7 0.11-0.2 0.16-0.51 0.51-0.76 0.38-0.26-0.14-0.46-0.43-0.46-1.08 0-0.64-0.68-1.2-0.05-1.17 0.62 0.03 1.41 0.48 1.55 0.13s0.06-0.51-0.28-0.78-0.76-0.43-0.31-0.77c0.45-0.35 0.56-0.35 0.74-0.54 0.17-0.18 0.41-0.79 0.73-0.64 0.62 0.3 0.02 0.73 0.65 1.42 0.62 0.69 1.01 0.94 2.06 0.83 1.04-0.11 1.33-0.24 1.33-0.54 0-0.29-0.09-0.82-0.12-1.04-0.02-0.21 0.15-0.99 0.15-0.99s-0.48 0.3-0.63 0.59c-0.13 0.29-0.42 0.8-0.42 0.8s-0.11-0.6-0.08-1.09c0.02-0.29 0.12-0.79 0.11-0.89-0.03-0.27-0.23-0.94-0.23-0.94s-0.16 0.73-0.28 0.94c-0.11 0.21-0.16 1.07-0.16 1.07s-0.67-0.58-0.48-1.55c0.13-0.75-0.12-1.74 0.11-2.06 0.22-0.33 0.75-1.64 2.06-1.69 1.3-0.05 2.31 0.05 2.77 0.03 0.45-0.03 2.06-0.33 2.06-0.33s-2.97-1.52-3.64-1.98c-0.68-0.45-1.73-1.63-2.07-2.16-0.34-0.54-0.65-1.58-0.65-1.58s-0.53 0.02-1.02 0.29c-0.48 0.27-0.96 0.67-1.24 0.99s-0.73 1.05-0.73 1.05 0.08-0.94 0.08-1.23-0.06-0.86-0.06-0.86-0.33 1.28-1.01 1.76c-0.68 0.49-1.47 1.15-1.47 1.15s0.08-0.71 0.08-0.88c0-0.16 0.17-0.99 0.17-0.99s-0.48 0.72-1.21 0.86c-0.74 0.13-1.81 0.11-1.9 0.56-0.08 0.45 0.2 1.07 0.03 1.39s-0.54 0.54-0.54 0.54-0.42-0.35-0.79-0.38c-0.36-0.03-0.71 0.16-0.71 0.16s-0.31-0.4-0.19-0.67c0.11-0.26 0.67-0.66 0.54-0.83-0.15-0.16-0.6 0.06-0.88 0.19-0.28 0.14-0.88 0.27-0.82-0.19 0.05-0.45 0.2-0.72 0.05-1.04-0.14-0.32-0.05-0.53 0.18-0.61 0.22-0.08 1.12 0.02 1.21-0.19 0.08-0.21-0.22-0.48-0.82-0.61-0.59-0.14-0.88-0.49-0.57-0.78 0.32-0.3 0.4-0.38 0.54-0.64 0.14-0.27 0.2-0.76 0.74-0.51 0.53 0.24 0.42 0.83 0.99 1.01 0.56 0.19 1.89-0.08 2.17-0.24s1.19-0.83 1.5-0.99c0.31-0.15 1.61-1.12 1.61-1.12s-0.76-0.53-1.05-0.8c-0.28-0.27-0.78-0.91-1.04-1.05-0.25-0.13-1.5-0.61-1.92-0.64-0.42-0.02-1.72-0.48-1.72-0.48s0.59-0.19 0.79-0.35c0.19-0.16 0.64-0.56 0.87-0.53 0.22 0.02 0.28 0.02 0.28 0.02s-1.21-0.05-1.47-0.13c-0.25-0.08-0.99-0.54-1.27-0.54s-0.84 0.11-0.84 0.11 0.76-0.48 1.38-0.59c0.62-0.1 1.1-0.08 1.1-0.08s-0.96-0.27-1.19-0.58c-0.22-0.33-0.45-0.8-0.62-1.02-0.17-0.21-0.28-0.56-0.59-0.59s-0.85 0.38-1.16 0.35-0.54-0.22-0.57-0.67c-0.02-0.46 0-0.3-0.1-0.54-0.12-0.24-0.57-0.8-0.15-0.93 0.43-0.14 1.33 0.08 1.42-0.08 0.08-0.16-0.48-0.65-0.85-0.83-0.37-0.19-0.96-0.51-0.65-0.78 0.31-0.26 0.62-0.37 0.79-0.61s0.37-0.91 0.74-0.7c0.36 0.21 0.87 1.26 1.16 1.18 0.28-0.08 0.3-0.83 0.25-1.15-0.06-0.32 0-0.88 0.28-0.83s0.51 0.43 0.96 0.46c0.45 0.02 1.13-0.11 1.07 0.21-0.05 0.32-0.31 0.71-0.62 1.06-0.3 0.36-0.45 1.05-0.25 1.5 0.2 0.46 0.71 1.19 1.16 1.48s1.3 0.51 1.84 0.85c0.53 0.35 1.78 1.34 2.2 1.45s0.85 0.32 0.85 0.32 0.48-0.21 1.13-0.21 2.14 0.1 2.71-0.14 1.3-0.64 1.08-1.15c-0.23-0.51-1.47-0.96-1.36-1.36s0.57-0.43 1.33-0.46c0.76-0.02 1.8 0.14 2-0.94 0.2-1.06 0.26-1.68-0.81-1.92-1.08-0.24-1.87-0.27-2.07-1.04-0.2-0.78-0.39-0.97-0.17-1.18 0.23-0.21 0.62-0.32 1.41-0.37 0.8-0.06 1.7-0.06 1.96-0.25 0.25-0.18 0.3-0.69 0.61-0.91 0.31-0.21 1.53-0.4 1.53-0.4s1.46 0.71 2.8 1.71c1.21 0.9 2.3 2.23 2.3 2.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269 243.39s-0.8 0.23-1.1 0.67c-0.37 0.53-0.34 1.07-0.34 1.07s0.68-0.56 1.56-0.33c0.87 0.24 0.96 0.33 1.33 0.3s1.27-0.35 1.27-0.35-0.74 0.86-0.65 1.45c0.08 0.58 0.19 0.85 0.17 1.15-0.06 0.72-0.6 1.61-0.6 1.61s0.31-0.19 1.05-0.35c0.73-0.16 1.36-0.51 1.75-0.81 0.39-0.29 0.9-1.02 0.9-1.02s-0.16 1 0 1.42c0.17 0.44 0.23 1.67 0.23 1.67s0.47-0.42 0.85-0.62c0.19-0.11 0.7-0.38 0.9-0.7 0.14-0.22 0.32-1.06 0.32-1.06s0.11 0.9 0.39 1.34c0.28 0.42 0.7 1.74 0.7 1.74s0.29-0.86 0.6-1.21 0.68-0.8 0.7-1.07c0.03-0.27-0.08-0.85-0.08-0.85l0.39 0.85m-11.41 0.61s0.48-0.83 0.93-1.1c0.46-0.26 1.08-0.74 1.25-0.8 0.16-0.05 0.9-0.46 0.9-0.46m0.99 5.17s1.09-0.55 1.41-0.75c0.68-0.4 1.16-1.12 1.16-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.26,
    d: "m282.57 240.9s-0.34-0.48-0.42-0.65c-0.09-0.15-0.23-0.48-0.23-0.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m278.33 257.41s2.04 1.26 1.98 2.31c-0.06 1.04-1.13 2.41-1.13 2.41"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.26,
    d: "m273.05 236.24s-0.17-0.48-0.2-0.62c-0.03-0.13-0.12-0.29-0.12-0.29s0.88 0 0.85 0.27c-0.02 0.27-0.28 0.27-0.34 0.37-0.05 0.11-0.19 0.27-0.19 0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.05,
    d: "m277.06 234.85l-0.06-0.43s0.77 0 1.13 0.26c0.57 0.4 0.93 1.02 0.91 1.05-0.1 0.09-0.54-0.27-0.85-0.37 0 0-0.23 0.05-0.45 0.05-0.23 0-0.34-0.11-0.37-0.21-0.03-0.12 0.03-0.3 0.03-0.3l-0.34-0.05z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    strokeWidth: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "m273.08 240.14l0.33-0.53 0.34 0.49-0.67 0.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.89 240.12l0.4-0.53 0.43 0.48-0.83 0.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.53 236.83l0.82 0.29-0.74 0.38-0.08-0.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.52 237.1l0.73 0.18-0.59 0.46-0.14-0.64"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#db4446",
    strokeWidth: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261.88 236.08s0.48 0.34 0.85 0.4c0.37 0.05 0.76 0.05 0.82 0.05 0.05 0 0.17-0.54 0.11-0.91-0.2-1.2-1.3-1.47-1.3-1.47s0.33 0.73 0.17 1.07c-0.23 0.48-0.65 0.86-0.65 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.59 237.12s-0.43-0.77-1.33-0.67c-0.9 0.11-1.5 0.81-1.5 0.81s1-0.03 1.25 0.13c0.37 0.24 0.48 0.86 0.48 0.86s0.54-0.32 0.71-0.54c0.16-0.21 0.39-0.59 0.39-0.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.49 240.25s-0.77 0.11-1.19 0.59c-0.43 0.49-0.36 1.4-0.36 1.4s0.5-0.54 0.95-0.54c0.46 0 1.16 0.16 1.16 0.16s-0.22-0.56-0.22-0.8-0.34-0.81-0.34-0.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.06 250.37s-0.42-0.45-1.16-0.32c-0.74 0.14-1.22 0.97-1.22 0.97s0.63-0.17 1-0.08c0.36 0.08 0.62 0.45 0.62 0.45s0.34-0.29 0.45-0.45 0.31-0.57 0.31-0.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.21 253.34s-0.62-0.1-1.16 0.33c-0.53 0.43-0.56 1.25-0.56 1.25s0.51-0.43 0.91-0.37c0.39 0.05 0.87 0.27 0.87 0.27s0.08-0.51 0.11-0.64c0.09-0.38-0.17-0.84-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.66 256.08s-0.05 0.79 0.33 1.28c0.4 0.51 1.13 0.59 1.13 0.59s-0.24-0.53-0.28-0.8c-0.06-0.4 0.34-0.75 0.34-0.75s-0.37-0.38-0.73-0.38c-0.37 0-0.79 0.06-0.79 0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269 263.12s-0.51-0.64-1.21-0.62c-0.71 0.03-1.45 0.69-1.45 0.69s0.88-0.07 1.11 0.22c0.23 0.3 0.45 0.67 0.45 0.67s0.4-0.21 0.57-0.35c0.17-0.13 0.53-0.61 0.53-0.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.83 265.93s-0.93-0.14-1.39 0.35c-0.45 0.48-0.42 1.36-0.42 1.36s0.56-0.61 1.07-0.56 1.08 0.32 1.08 0.32-0.09-0.53-0.15-0.78c-0.05-0.24-0.19-0.69-0.19-0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.84 268.9s-0.46 0.64-0.12 1.15 1.05 0.75 1.05 0.75-0.26-0.37-0.14-0.8c0.09-0.34 0.67-0.8 0.67-0.8l-1.46-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.24 270.11s-0.81-0.19-1.27 0.08c-0.45 0.26-0.82 1.39-0.82 1.39s0.74-0.62 1.28-0.54c0.53 0.08 0.93 0.3 0.93 0.3s0.08-0.46 0.02-0.78c-0.03-0.19-0.14-0.45-0.14-0.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.64 273.1s-0.62 0.64-0.4 1.18c0.23 0.54 0.62 1.1 0.62 1.1s-0.02-0.8 0.23-1.02c0.37-0.32 1.05-0.37 1.05-0.37s-0.54-0.48-0.71-0.54c-0.17-0.05-0.79-0.35-0.79-0.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.75 274.04s-0.31 0.78 0.28 1.28c0.59 0.52 1.11 0.57 1.11 0.57s-0.46-0.81-0.32-1.23c0.15-0.45 0.54-0.72 0.54-0.72s-0.74-0.25-0.85-0.22c-0.11 0.02-0.76 0.32-0.76 0.32z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100",
    strokeWidth: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.88 232.71l-0.29 0.02c-0.01 0.03-0.14 0.24-0.26 0.35-0.26 0.25-0.65 0.28-0.86 0.07-0.11-0.11-0.16-0.26-0.14-0.41-0.17 0.09-0.35 0.09-0.51-0.01-0.26-0.15-0.32-0.5-0.14-0.79 0.03-0.06 0.06-0.14 0.11-0.18l-0.02-0.32-0.35 0.08-0.1 0.19c-0.22 0.25-0.54 0.31-0.7 0.17-0.08-0.07-0.14-0.26-0.13-0.27 0 0.01-0.09 0.09-0.17 0.11-0.54 0.13-0.75-1.05-0.77-1.35l-0.17 0.25s0.16 0.7 0.08 1.3c-0.08 0.59-0.29 1.19-0.29 1.19 0.74 0.19 1.86 0.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 0.58-0.32 1.18-0.51s1.36-0.2 1.36-0.2l0.22-0.21c-0.32 0.05-1.58 0.1-1.56-0.43 0-0.08 0.07-0.18 0.08-0.18-0.01 0.01-0.21-0.01-0.3-0.06-0.18-0.13-0.18-0.43 0.02-0.69l0.18-0.13 0.01-0.34-0.34 0.05c-0.03 0.04-0.11 0.09-0.15 0.13-0.27 0.23-0.65 0.25-0.86 0.03-0.13-0.12-0.17-0.29-0.11-0.46-0.16 0.04-0.32 0.03-0.45-0.05-0.26-0.15-0.31-0.52-0.11-0.8 0.09-0.14 0.28-0.31 0.31-0.32l-0.07-0.3h-0.01z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    strokeWidth: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.63 233.4c0.05-0.07 0.15-0.06 0.23 0s0.1 0.16 0.06 0.21c-0.05 0.06-0.15 0.06-0.24-0.01-0.07-0.05-0.1-0.15-0.05-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.58 234.19l-0.33-0.25c-0.06-0.04-0.07-0.12-0.04-0.16 0.04-0.04 0.12-0.04 0.18 0l0.33 0.26 0.33 0.25c0.05 0.04 0.08 0.12 0.04 0.16s-0.12 0.04-0.18 0l-0.33-0.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.84 233l-0.26-0.15c-0.07-0.04-0.1-0.12-0.07-0.17s0.11-0.06 0.17-0.02l0.26 0.16 0.26 0.15c0.06 0.03 0.09 0.11 0.07 0.16-0.03 0.05-0.11 0.06-0.17 0.02l-0.26-0.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.8 232.29c0.05-0.06 0.16-0.06 0.24 0 0.08 0.07 0.1 0.16 0.05 0.22-0.05 0.05-0.15 0.05-0.23-0.01s-0.1-0.15-0.06-0.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.63 234.92c0.05-0.05 0.03-0.14-0.05-0.21-0.08-0.06-0.19-0.06-0.24 0-0.04 0.05-0.02 0.15 0.06 0.21s0.18 0.06 0.23 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.2 235.58l0.22 0.21c0.05 0.05 0.13 0.07 0.18 0.03 0.04-0.04 0.04-0.11-0.01-0.16l-0.21-0.21-0.22-0.21c-0.05-0.05-0.14-0.07-0.18-0.03-0.05 0.03-0.04 0.11 0.01 0.16l0.21 0.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.15 236.39c0.05-0.06 0.03-0.15-0.05-0.21-0.08-0.07-0.18-0.07-0.23-0.01s-0.03 0.15 0.05 0.22c0.08 0.05 0.18 0.06 0.23 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.8 230.84l-0.02 0.54 0.92 0.12 0.15-0.07-0.02-0.15-0.53-0.71-0.5 0.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.7 231.92l-0.49 0.27-0.54-0.71-0.01-0.15 0.14-0.06 0.93 0.11-0.03 0.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.51 231.25c0.08-0.13 0.26-0.17 0.39-0.09 0.14 0.07 0.18 0.24 0.1 0.37s-0.26 0.17-0.39 0.09c-0.14-0.08-0.18-0.24-0.1-0.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.36 230.35c-0.02 0.01-0.13-0.46-0.26-0.71-0.08-0.19-0.39-0.43-0.39-0.43 0.03-0.05 0.42-0.19 0.87 0.09 0.38 0.31-0.03 0.87-0.03 0.87s-0.09 0.14-0.19 0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.39 230.66l-0.42 0.37-0.68-0.6 0.06-0.08 0.03-0.15 0.92-0.07 0.09 0.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.24 230.29c0.05-0.15 0.18-0.23 0.28-0.2 0.11 0.04 0.15 0.18 0.1 0.33s-0.18 0.23-0.29 0.2c-0.11-0.04-0.15-0.18-0.09-0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.67 231.77l-0.59-0.06-0.25 0.85 0.05 0.14 0.15 0.01 0.83-0.41-0.19-0.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.01 232.03l-0.1 0.54 0.9 0.23 0.15-0.04 0.01-0.14-0.43-0.79-0.53 0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.73 233.36l-0.53 0.2-0.42-0.78 0.01-0.15 0.15-0.03 0.89 0.23-0.1 0.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.65 232.54c0.1-0.12 0.28-0.13 0.4-0.04 0.13 0.09 0.15 0.26 0.05 0.38s-0.28 0.13-0.41 0.04c-0.12-0.09-0.14-0.26-0.04-0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.64 233.61l0.11 0.55-0.87 0.3-0.16-0.04-0.01-0.14 0.36-0.81 0.57 0.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.49 235.2l-0.56 0.13-0.31-0.83 0.04-0.15 0.15-0.02 0.85 0.35-0.17 0.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.97 233.66l-0.18 0.52 0.85 0.34 0.16-0.02 0.03-0.14-0.3-0.83-0.56 0.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.91 234.63c0.12-0.11 0.12-0.28 0.02-0.39-0.11-0.11-0.29-0.11-0.41-0.02-0.11 0.11-0.12 0.28-0.01 0.39 0.1 0.11 0.29 0.12 0.4 0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.29 236.43c0 0.01 0.5 0.03 0.79 0.09 0.2 0.04 0.52 0.27 0.52 0.27 0.06-0.04 0.12-0.42-0.28-0.79-0.39-0.28-0.88 0.22-0.88 0.22s-0.12 0.12-0.15 0.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.75 235.54l-0.29 0.46 0.76 0.51 0.09-0.08 0.13-0.04-0.12-0.88-0.57 0.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.37 236.53c0.14-0.07 0.21-0.22 0.15-0.31s-0.22-0.1-0.36-0.02-0.2 0.22-0.14 0.31c0.05 0.09 0.21 0.1 0.35 0.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "inescutcheon",
    strokeWidth: 0.61
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ad1519",
    cx: 250.43,
    cy: 281.01,
    rx: 16.26,
    ry: 18.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#005bbf",
    cx: 250.44,
    cy: 280.97,
    rx: 11.44,
    ry: 13.42
  }), /*#__PURE__*/React.createElement("g", {
    id: "fdl",
    fill: "#c8b100",
    strokeWidth: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39 0.57 2.54 0.57 2.54-0.21-0.55-0.76-0.94-1.41-0.94-0.83 0-1.5 0.63-1.5 1.42 0 0.22 0.14 0.58 0.24 0.77l0.49 0.99c0.16-0.37 0.54-0.57 0.98-0.57 0.59 0 1.08 0.45 1.08 1.01 0 0.09-0.01 0.17-0.04 0.25l-1.22 0.01v1.03h1.09l-0.81 1.61 1.07-0.42 0.81 0.91 0.84-0.91 1.07 0.42-0.8-1.61h1.08v-1.03l-1.22-0.01c-0.02-0.08-0.02-0.16-0.02-0.25 0-0.56 0.47-1.01 1.06-1.01 0.44 0 0.82 0.2 0.98 0.57l0.49-0.99c0.1-0.19 0.24-0.55 0.24-0.77 0-0.79-0.67-1.42-1.49-1.42-0.66 0-1.21 0.39-1.41 0.94 0 0 0.57-1.15 0.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.87 281.11h4.36v-1.03h-4.36v1.03z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fdl",
    x: 10.63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fdl",
    x: 5.31,
    y: 9.14
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishFlag);
export default __webpack_public_path__ + "static/media/spanish_flag.7b5666a783b4c2193c42218e365f7e75.svg";
export { ForwardRef as ReactComponent };